var   KEYS  = require('../../keys/Keys');
var   AXIOS = require('axios');

export {DeleteFirmwareAsync as InvokeAsync , DeleteFirmwareSync as InvokeSync}

async function DeleteFirmwareAsync(LoginToken,FirmwareUUID)
{
    var DeleteFirmwarePromise = new Promise((resolve, reject) => {
        DeleteFirmwareSync(LoginToken,FirmwareUUID,(response,error) => {
            if (error) {  
                try{ 
                    return reject(error.response.data.message);
                }catch(ex){
                    return reject('Unknown error');
                }
            }
            if(response.status==='fails'){
                reject(response.error);
            }else{
                resolve(null);
            }
        });
    });

    return await DeleteFirmwarePromise;
}

function DeleteFirmwareSync(LoginToken,FirmwareUUID,Callback)
{
    AXIOS({
        headers:{
            'Content-Type': 'application/json',
            'x-api-key'   : KEYS.AWS_XKEY,
        },
        method : 'post',
        url    :'/Admin/DeleteFirmware',                
        data  : {
            AppID       :KEYS.AWS_APPID,
            FirmwareUUID :FirmwareUUID ,
            LoginToken  :LoginToken             
        },                                
    })
    .then((response)=>{
        Callback(response.data,null);
    },(error) => { 
        Callback(null,error + ' ');
    });
}
